module.exports = __webpack_public_path__ + "img/commit_book.ad35e673.png";